import { motion } from "framer-motion";
import { SAFETY_AREAS } from "@/data/content";

export const SafetyEngineering = () => (
  <section data-testid="safety-engineering-section" className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <h2
          data-testid="safety-engineering-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          Engineered for Each Site
        </h2>
        <p data-testid="safety-engineering-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
          Hydrogen, electrical, pressure and control systems require project-specific
          engineering, equipment selection, permitting, installation and commissioning.
        </p>
      </motion.div>

      <div className="mt-10 grid grid-cols-1 border-t border-borderLight sm:grid-cols-2 lg:mt-12">
        {SAFETY_AREAS.map((area, i) => {
          const row = Math.floor(i / 2);
          const col = i % 2;
          return (
            <motion.div
              key={area.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`safety-area-${i}`}
              className={`pt-6 sm:pt-8 ${area.title === "Commissioning" ? "pb-[4px]" : "pb-6"} sm:pb-8 ${i < 3 ? "border-b border-borderLight" : ""} ${
                row === 0 ? "sm:border-b sm:border-borderLight" : "sm:border-b-0"
              } ${col === 0 ? "sm:border-r sm:border-borderLight sm:pr-8" : "sm:pl-8"}`}
            >
              <span className="text-xs font-medium uppercase tracking-[0.1em] text-inkMuted">{area.title}</span>
              {area.title === "Commissioning" ? (
                <p className="mt-3 text-sm leading-relaxed text-inkSoft">
                  Final installations will follow the applicable professional review, inspection, acceptance
                  <br className="hidden lg:block" /> and commissioning requirements.
                </p>
              ) : (
                <p className="mt-3 text-sm leading-relaxed text-inkSoft">{area.body}</p>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
